import { HealthApiModels } from 'models/api/health-api.models';
import { HealthRiskModels } from 'models/health-risk.models';
import { HealthModels } from 'models/health.models';
import { QuotationModels } from 'models/quotation.models';
import { DateProjector } from './date-projector';

export const projectHealthPolicyPricingMetadatasResponse = (
  response: HealthApiModels.HealthPolicyPricingMetadatasResponse,
): HealthModels.HealthPolicyPricingMetadatas => {
  return {
    brokerCommissions: response.brokerCommissions,
    clientPrice: response.clientPrice,
    commission: {
      max: response.maxLoading,
      min: 0,
    },
    formulas: response.formulas,
    management: {
      min: response.minFees,
      max: response.maxFees,
    },
    selectedFees: response.selectedFees,
    selectedFormula: response.selectedFormula,
    selectedLoading: response.selectedLoading,
    selectedOptionnalWarranties: response.selectedOptionnalWarranties,
    staggering: response.staggering,
    commissionType: response.commissionType,
    healthRateLinear: response.healthRateLinear,
    healthRateWithholding: response.healthRateWithholding,
    isWithholdingThresholdExceeded: response.isWithholdingThresholdExceeded,
    listeReponseAfi: response.listeReponseAfi,
  };
};

export const projectHealthQuotationRequest = (
  request: HealthModels.QuotationRequest,
): HealthApiModels.QuotationRequest => {
  return {
    commissionType: request.commissionType,
    risk: projectHealthRiskToApi(request.risk),
    brokerFees: request.brokerFees,
    quotationParamOrigin: request.quotationParamOrigin,
    quotationCodeOrigin: request.quotationCodeOrigin,
    quotationCodeParrain: request.quotationCodeParrain,
    quotationBaseOrigin: request.quotationBaseOrigin,
    quotationAcceptCompMT: request.quotationAcceptCompMT,
    quotationNavigator: request.quotationNavigator,
    controlListeParam: request.controlListeParam,
    brokerLoading: request.brokerLoading,
    formula: request.formula,
    optionalWarranties: request.optionalWarranties,
    staggering: request.staggering,
    packageId: request.packageId,
    tarifPrix: request.tarifPrix,
    TypeProduit: request.TypeProduit,
    codeFormule: request.codeFormule,
  };
};

export const projectHealthRiskToApi = (
  risk: HealthRiskModels.Risk,
): HealthRiskModels.Risk => {
  return {
    assure: risk.assure,
    vadInfo: risk.vadInfo,
    universBesoinInfo: risk.universBesoinInfo,
    ria: risk.ria,
    assurePrincipal: getAssurePrincipalToAssurePrincipalApi(
      risk.assurePrincipal,
    ),
    effectDate: risk.effectDate,
    // effectDate: DateProjector.fromAppToApi(risk.effectDate),
    family: {
      conjoint: risk.family.conjoint
        ? getAssureToAssureApi(risk.family.conjoint)
        : undefined,
      enfants: risk.family.enfants
        ? risk.family.enfants.map((ef) => getAssureToAssureApi(ef))
        : [],
    },
  };
};

export const projectApiHealthRiskToModel = (
  risk: HealthRiskModels.Risk,
): HealthRiskModels.Risk => {
  console.log('DATE EFFET Sur RISK: ' + risk.effectDate);
  return {
    assure: risk.assure,
    vadInfo: risk.vadInfo,
    universBesoinInfo: risk.universBesoinInfo,
    ria: risk.ria,
    assurePrincipal: getApiAssurePrincipalToModel(risk.assurePrincipal),
    effectDate: DateProjector.fromApiToApp(risk.effectDate)!,
    family: {
      conjoint: risk.family.conjoint
        ? getApiAssureToAssure(risk.family.conjoint)
        : undefined,
      enfants: risk.family.enfants
        ? risk.family.enfants.map((ef) => getApiAssureToAssure(ef))
        : [],
    },
  };
};

function getApiAssureToAssure(
  assure: HealthRiskModels.Assure,
): HealthRiskModels.Assure {
  return {
    personData: {
      isDisabled: assure.personData.isDisabled,
      civility: assure.personData.civility,
      dateNaissance: DateProjector.fromApiToApp(
        assure.personData.dateNaissance,
      )!,
      firstName: assure.personData.firstName,
      lastName: assure.personData.lastName,
    },
    securiteSocialData: {
      regimeSocial: assure.securiteSocialData.regimeSocial,
      numeroOrganisme: assure.securiteSocialData.numeroOrganisme,
      numeroSecuriteSocial: assure.securiteSocialData.numeroSecuriteSocial,
      beneficiaryOf: assure.securiteSocialData.beneficiaryOf,
    },
  };
}

function getApiAssurePrincipalToModel(
  assure: HealthRiskModels.AssurePrincipal,
): HealthRiskModels.AssurePrincipal {
  return {
    ...getApiAssureToAssure(assure),
  };
}

function getAssureToAssureApi(
  assure: HealthRiskModels.Assure,
): HealthRiskModels.Assure {
  return {
    personData: {
      isDisabled: assure.personData.isDisabled,
      civility: assure.personData.civility,
      //   dateNaissance: DateProjector.fromAppToApi(assure.personData.dateNaissance),
      dateNaissance: assure.personData.dateNaissance,
      firstName: assure.personData.firstName,
      lastName: assure.personData.lastName,
    },
    securiteSocialData: {
      regimeSocial: assure.securiteSocialData.regimeSocial,
      numeroOrganisme: assure.securiteSocialData.numeroOrganisme,
      numeroSecuriteSocial: assure.securiteSocialData.numeroSecuriteSocial,
    },
  };
}

const getAssurePrincipalToAssurePrincipalApi = (
  assure: HealthRiskModels.AssurePrincipal,
): HealthRiskModels.AssurePrincipal => {
  return {
    ...getAssureToAssureApi(assure),
  };
};

export const projectApiQuotationToModel = (
  apiQuotation: HealthApiModels.GetQuotationResponse,
): HealthModels.QuotationSummary => {
  const { quotationRequest, pricingInfos } = apiQuotation.data;
  let quotation: HealthModels.QuotationSummary | any = {
    package: apiQuotation.data.packageId,
    isWithholdingThresholdExceeded:
      apiQuotation.data.isWithholdingThresholdExceeded,
    publicId: apiQuotation.publicId,
    creationDate: apiQuotation.creationDate,
    signatureReadyDate:
      apiQuotation.data.quotationRequest.risk.vadInfo.signatureReadyDate,
    formulaChoice: {
      formula: quotationRequest.formula,
      optionalWarranties: quotationRequest.optionalWarranties,
    },
    brokerFeesChoice: {
      loading: quotationRequest.brokerLoading,
      management: quotationRequest.brokerFees,
      type: quotationRequest.commissionType,
      healthRateLinear: quotationRequest.healthRateLinear,
      healthRateWithholding: quotationRequest.healthRateWithholding,
    },
    periodicPricing: getPeriodicPricing(
      pricingInfos.pricing,
      quotationRequest.staggering!,
    ),
    risk: projectApiHealthRiskToModel(quotationRequest.risk),
    staggering: quotationRequest.staggering,
    status: apiQuotation.status,
    files: apiQuotation.data.files,
    rib: apiQuotation.data.rib,
    tarifPrix: apiQuotation.data.quotationRequest.tarifPrix,
    TypeProduit: apiQuotation.data.quotationRequest.TypeProduit,
    codeFormule: apiQuotation.data.quotationRequest.codeFormule,
  };

  return quotation;
};

function getPeriodicPricing(
  pricing: QuotationModels.Staggered<QuotationModels.DetailedPricing>,
  staggering: QuotationModels.QuittancementEnum,
): number {
  if (staggering === QuotationModels.QuittancementEnum.Annuel) {
    return pricing.yearly.clientTotalPrice;
  } else {
    return pricing.monthly.clientTotalPrice;
  }
}
export const projectRiskToSubscriptionForm = (
  risk: HealthRiskModels.Risk,
  rib: HealthModels.FinancialInfo,
): HealthModels.SubscriptionForm | any => {
  const conjoint = risk.family ? risk.family.conjoint : undefined;
  const enfants = risk.family ? risk.family.enfants : undefined;
  return {
    assurePrincipal: {
      numeroOrganismeAffiliation:
        risk.assurePrincipal.securiteSocialData.numeroOrganisme,
      numeroSS: risk.assurePrincipal.securiteSocialData.numeroSecuriteSocial,
    },

    conjoint: projectFamilyPerson(conjoint!),
    vadInfos: risk.vadInfo,
    ria: risk.ria,
    enfants: !!enfants ? enfants.map(projectFamilyPerson) : null,
    financial: rib
      ? {
          mainRib: rib.mainRib,
          refundRib: rib.refundRib,
          isRefundRibDifferent:
            !!rib.refundRib && rib.mainRib !== rib.refundRib,
          quantieme: rib.quantieme,
        }
      : null,
  };
};

function projectFamilyPerson(
  assure: HealthRiskModels.Assure,
): HealthModels.SubscriptionFamilyPerson | any {
  if (!assure) {
    return null;
  }

  return {
    civilite: assure.personData.civility,
    prenom: assure.personData.firstName,
    nom: assure.personData.lastName,
    numeroSS: assure.securiteSocialData.numeroSecuriteSocial,
    numeroOrganismeAffiliation: assure.securiteSocialData.numeroOrganisme,
    beneficiaryOf: assure.securiteSocialData.beneficiaryOf,
  };
}

export const projectSubscriptionFormToApi = (
  subscriptionForm: HealthModels.SubscriptionForm,
): HealthApiModels.CreateHealthPropositionRequest => {
  return {
    assurePrincipal: subscriptionForm.assurePrincipal,
    vadInfos: subscriptionForm.vadInfos,
    ria: subscriptionForm.ria,
    conjoint: subscriptionForm.conjoint,
    enfants: subscriptionForm.enfants,
    financial: {
      mainRib: subscriptionForm.financial.mainRib,
      refundRib: subscriptionForm.financial.refundRib,
      quantieme: subscriptionForm.financial.quantieme,
    },
  };
};

/** INTERNAL RISK <==> FORMS */

export const getQuotationFormFromRisk = (
  risk: HealthRiskModels.Risk,
  formula: QuotationModels.FormulaEnum,
): HealthModels.QuotationForm | any => {
  if (!risk) {
    return null;
  }

  return {
    assureInfos: risk.assure,
    vadInfo: risk.vadInfo,
    assurePrincipal: getAssurePrincipalFormFromRisk(risk),
    family: {
      conjoint: risk.family.conjoint
        ? getFamilyPersonFromAssure(
            risk.family.conjoint,
            risk.assurePrincipal.securiteSocialData.regimeSocial,
          )
        : null,
      enfants: risk.family.enfants
        ? risk.family.enfants.map((ef) =>
            getFamilyPersonFromAssure(
              ef,
              risk.assurePrincipal.securiteSocialData.regimeSocial,
            ),
          )
        : [],
    },
    universBesoinInfo: {
      ...risk.universBesoinInfo,
      formula: formula,
    },
  };
};

function getAssurePrincipalFormFromRisk(
  risk: HealthRiskModels.Risk,
): HealthModels.Assure {
  return {
    dateEffet: risk.effectDate,
    dateNaissance: risk.assurePrincipal.personData.dateNaissance,
    regimeSocial: risk.assurePrincipal.securiteSocialData.regimeSocial,
    groupVille: {
      inseeCode: risk.assure.address.codeInsee,
      ville: risk.assure.address.cityName,
      codePostal: risk.assure.address.cityZipCode,
    },
  };
}

function getFamilyPersonFromAssure(
  assure: HealthRiskModels.Assure,
  assureRegimeSocial: HealthModels.RegimeSocialEnum,
): HealthModels.FamilyPerson {
  return {
    dateNaissance: assure.personData.dateNaissance,
    isRegimeSocialDifferent:
      assure.securiteSocialData.regimeSocial !== assureRegimeSocial,
    regimeSocial: assure.securiteSocialData.regimeSocial,
    isDisabled: assure.personData.isDisabled,
  };
}
